<template>
	<div class="single-flex-row">
		<td class="mh-days text-align-center">
			<p class="right-td td-element-center">{{monthlyAllocation.totalWorkingDays}}</p>
		</td>
		<td class="mh-vac">
			<p class="right-td td-element-center">{{monthlyAllocation.totalVacation}}</p>
		</td>
		<td class="mh-sick">
			<p class="right-td td-element-center">{{monthlyAllocation.totalSick}}</p>
		</td>
		<td class="mh-other">
			<p class="right-td td-element-center">{{monthlyAllocation.other}}</p>
		</td>
		<td class="mh-act">
			<!-- <p class="right-td"></!-->
			<p class="right-td td-element-center">{{monthlyAllocation.actualWorkingDays}}</p>
		</td>
		<td class="tv">
			<p
				class="right-td td-element-center left-days-cell-i"
				:class="daysLeftClass"
			>{{monthlyAllocation.engaged}}%</p>
		</td>
	</div>
</template>

<script>
export default {
  name: "ConsultantworkloadAllocationMonth",
  props: ["monthlyAllocation"],
  computed: {
    metadata: function() {
      return this.$store.state.reports.consultantWorkloadMetadata;
    },
    daysLeftClass: function() {
      let metadata = this.metadata;
      if (
        parseInt(this.monthlyAllocation.engaged) >=
        parseInt(metadata.consultantWorkloadGreen)
      ) {
        return "blue";
      } else if (
        parseInt(this.monthlyAllocation.engaged) >=
          parseInt(metadata.consultantWorkloadRed) &&
        parseInt(this.monthlyAllocation.engaged) <
          parseInt(metadata.consultantWorkloadGreen)
      ) {
        return "yellow";
      } else {
        return "red";
      }
    }
  }
};
</script>

<style scoped>
	.mh-days {
		min-width: 62px;
		max-width: 62px;
		width: 62px;
		padding-left: 16px;
	}

	.mh-vac {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.mh-sick {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.mh-other {
		min-width: 50px;
		max-width: 50px;
		width: 50px;
	}

	.mh-act {
		min-width: 42px;
		max-width: 42px;
		width: 42px;
	}

	.mh-tv {
		min-width: 70px;
		max-width: 70px;
		width: 70px;
	}

	.td-element-center {
		text-align: center;
		width: 23px;
		display: inline-block;
		margin: 0 auto;
	}

	.mh-other .td-element-center {
		width: 34px;
	}

	.tv .td-element-center {
		width: 55px;
		text-align: right;
	}

	.consultant-workload-sep td.right-td {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		line-height: 0;
	}

	.consultant-workload-sep td.right-td p {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		/* old code  */
		/* line-height: 56px; */
		/* line-height: 34px; */
	}

	.consultant-workload-sep td.right-td.tv {
		text-align: right;
		padding-right: 15px;
	}

	.tv {
		width: 75px;
	}
</style>